/**
 * AJAX Category Filtering
 * Handles filtering for blog posts, team members, and testimonials via AJAX
 */

document.addEventListener('DOMContentLoaded', function () {
  const archiveSections = [
    {
      wrapperSelector: '.blog-index--acf',
      action: 'filter_blog_posts',
      categoryParam: 'blog_category',
      requestParam: 'child_slug',
      contentSelector: '.blog-posts',
      paginationSelector: '.pagination',
      hasParentSlug: true,
    },
    {
      wrapperSelector: '.team-member-index--acf',
      action: 'filter_team_members',
      categoryParam: 'team_category',
      requestParam: 'child_slug',
      contentSelector: '.team-member-posts',
      paginationSelector: '.pagination',
      hasParentSlug: true,
    },
    {
      wrapperSelector: '.testimonial-index--acf',
      action: 'filter_testimonials',
      categoryParam: 'testimonial_category',
      requestParam: 'testimonial_category',
      contentSelector: '.testimonial-posts',
      paginationSelector: '.pagination',
      hasParentSlug: false,
    },
    {
      wrapperSelector: '.podcast-index--acf',
      action: 'filter_podcast_episodes',
      categoryParam: null,
      requestParam: 'podcast_category',
      contentSelector: '.podcast-posts',
      paginationSelector: '.pagination',
      hasParentSlug: false,
    },
    {
      wrapperSelector: '.video-index--acf',
      action: 'filter_videos',
      categoryParam: 'video_category',
      requestParam: 'video_category',
      contentSelector: '.video-posts',
      paginationSelector: '.pagination',
      hasParentSlug: false,
    },
    {
      wrapperSelector: '.webinar-index--acf',
      action: 'filter_webinars',
      categoryParam: 'webinar_category',
      requestParam: 'webinar_category',
      contentSelector: '.video-posts',
      paginationSelector: '.pagination',
      hasParentSlug: false,
    },
  ];

  archiveSections.forEach(initArchiveSection);

  document.addEventListener('click', function (e) {
    const paginationLink = e.target.closest('.pagination a');
    if (!paginationLink) return;

    const section = findArchiveSection(paginationLink);
    if (!section) return;

    const config = archiveSections.find(entry => section.matches(entry.wrapperSelector));
    if (!config) return;

    e.preventDefault();

    const activeButton = section.querySelector('.category-filter-buttons__button.is-active');
    const categorySlug = activeButton && config.categoryParam
      ? (new URL(activeButton.href, window.location.href).searchParams.get(config.categoryParam) || '')
      : '';
    const page = getPageFromHref(paginationLink.href);

    if (config.hasParentSlug && !getParentSlugFromClass(section)) {
      return;
    }

    loadArchiveSection({
      action: config.action,
      section,
      contentSelector: config.contentSelector,
      paginationSelector: config.paginationSelector,
      categoryParam: config.categoryParam,
      requestParam: config.requestParam,
      categorySlug,
      page,
      parentSlug: config.hasParentSlug ? getParentSlugFromClass(section) : null,
    });
  });

  function initArchiveSection(config) {
    const sections = document.querySelectorAll(config.wrapperSelector);
    if (!sections.length) return;

    sections.forEach(section => {
      const filterButtons = section.querySelectorAll('.category-filter-buttons__button');
      if (!filterButtons.length) return;

      createMobileCategorySelect(section, filterButtons, config);

      filterButtons.forEach(button => {
        button.addEventListener('click', function (e) {
          e.preventDefault();

          const categorySlug = getSearchParamFromHref(this.href, config.categoryParam);

          if (config.hasParentSlug && !getParentSlugFromClass(section)) {
            return;
          }

          updateActiveState(filterButtons, this);

          loadArchiveSection({
            action: config.action,
            section,
            contentSelector: config.contentSelector,
            paginationSelector: config.paginationSelector,
            categoryParam: config.categoryParam,
            requestParam: config.requestParam,
            categorySlug,
            page: 1,
            parentSlug: config.hasParentSlug ? getParentSlugFromClass(section) : null,
          });
        });
      });
    });
  }

  function createMobileCategorySelect(section, filterButtons, config) {
    const container = section.querySelector('.category-button-container');
    if (!container) return;
    if (section.querySelector('.category-filter-select-container')) return;

    const selectContainer = document.createElement('div');
    selectContainer.className = 'category-filter-select-container';

    const selectId = `category-filter-select-${Math.random().toString(36).substr(2, 5)}`;
    const label = document.createElement('label');
    label.className = 'category-filter-label';
    label.setAttribute('for', selectId);
    label.textContent = 'Filter by category';

    const select = document.createElement('select');
    select.className = 'category-filter-select';
    select.id = selectId;
    select.setAttribute('aria-label', 'Select category');

    selectContainer.appendChild(label);
    selectContainer.appendChild(select);

    filterButtons.forEach((button, index) => {
      const option = document.createElement('option');
      option.value = button.href;
      option.textContent = button.textContent.trim();
      if (button.classList.contains('is-active')) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    select.addEventListener('change', function () {
      const selectedUrl = this.value;
      const categorySlug = getSearchParamFromHref(selectedUrl, config.categoryParam);

      if (config.hasParentSlug && !getParentSlugFromClass(section)) {
        return;
      }

      const selectedButton = filterButtons[this.selectedIndex];
      if (selectedButton) {
        updateActiveState(filterButtons, selectedButton);
      }

      loadArchiveSection({
        action: config.action,
        section,
        contentSelector: config.contentSelector,
        paginationSelector: config.paginationSelector,
        categoryParam: config.categoryParam,
        requestParam: config.requestParam,
        categorySlug,
        page: 1,
        parentSlug: config.hasParentSlug ? getParentSlugFromClass(section) : null,
      });
    });

    selectContainer.appendChild(select);
    container.insertBefore(selectContainer, container.firstChild);
  }

  function loadArchiveSection({
    action,
    section,
    contentSelector,
    paginationSelector,
    categoryParam,
    requestParam,
    categorySlug,
    page,
    parentSlug,
  }) {
    const postsContainer = section.querySelector(contentSelector);
    if (!postsContainer) return;

    postsContainer.classList.add('loading');

    const body = new URLSearchParams({
      action,
      nonce: categoryFilterData.nonce,
    });

    if (requestParam) {
      if (categorySlug) {
        body.set(requestParam, categorySlug);
      } else {
        body.set(requestParam, '');
      }
    }

    if (page > 1) {
      body.set('paged', page);
    }

    if (parentSlug) {
      body.set('parent_slug', parentSlug);
    }

    fetch(categoryFilterData.ajaxurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body,
    })
      .then(response => response.json())
      .then(data => {
        if (!data.success) {
          postsContainer.classList.remove('loading');
          return;
        }

        postsContainer.innerHTML = data.data.html;
        if (typeof window.initializeScrollAnimations === 'function') {
          window.initializeScrollAnimations();
        }

        const paginationContainer = section.querySelector(paginationSelector);
        if (paginationContainer) {
          paginationContainer.innerHTML = data.data.pagination || '';
        }

        updateBrowserUrl(categoryParam, categorySlug, page);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        postsContainer.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error:', error);
        postsContainer.classList.remove('loading');
      });
  }

  function updateBrowserUrl(categoryParam, categorySlug, page) {
    const newUrl = new URL(window.location);
    let pathname = newUrl.pathname;
    pathname = pathname.replace(/\/page\/\d+\/?$/, '');
    newUrl.pathname = pathname;

    if (categoryParam) {
      if (categorySlug) {
        newUrl.searchParams.set(categoryParam, categorySlug);
      } else {
        newUrl.searchParams.delete(categoryParam);
      }
    }

    if (page > 1) {
      newUrl.searchParams.set('paged', page);
    } else {
      newUrl.searchParams.delete('paged');
    }

    window.history.pushState({}, '', newUrl.toString());
  }

  function getPageFromHref(href) {
    const url = new URL(href, window.location.href);
    const queryPage = url.searchParams.get('paged');
    if (queryPage) {
      return parseInt(queryPage, 10) || 1;
    }

    const pathMatch = url.pathname.match(/\/page\/(\d+)\/?$/);
    if (pathMatch) {
      return parseInt(pathMatch[1], 10) || 1;
    }

    return 1;
  }

  function updateActiveState(buttons, activeButton) {
    buttons.forEach(button => button.classList.remove('is-active'));
    activeButton.classList.add('is-active');
  }

  function findArchiveSection(element) {
    return archiveSections.reduce((found, config) => found || element.closest(config.wrapperSelector), null);
  }

  function getSearchParamFromHref(href, paramName) {
    if (!paramName) {
      return '';
    }
    const url = new URL(href, window.location.href);
    return url.searchParams.get(paramName) || '';
  }

  /**
   * Extract parent slug from element's class
   * Looks for pattern like blog-index--{slug} or team-member-index--{slug}
   */
  function getParentSlugFromClass(element) {
    if (!element) return null;

    const classes = element.className.split(' ');
    const reservedBlogSlugs = ['blog-index--acf', 'blog-index--tag', 'blog-index--category'];

    for (let className of classes) {
      if (className.startsWith('blog-index--') && !reservedBlogSlugs.includes(className)) {
        return className.replace('blog-index--', '');
      }
      if (className.startsWith('team-member-index--') && className !== 'team-member-index--acf') {
        return className.replace('team-member-index--', '');
      }
    }
    return null;
  }
});
